import type { IRecentReview } from '@/entities/review/model/types';

export const adaptRecentReviews = (data: IRecentReview[]): IRecentReview[] => {
  return data.map(review => {
    return {
      ...review,
      owner: {
        ...review.owner,
        avatar: ['dev', 'local'].includes(process.env.NEXT_PUBLIC_ENV)
          ? `https://idoctor.kz/${review.owner.avatar}`
          : review.owner.avatar,
      },
    };
  });
};
